import React from "react";

// Centered Reflecta brand lockup used at the top of the auth dialog.
// Brand tokens: gradient #9B30FF -> #6A0DAD, Plus Jakarta Sans (loaded globally).
const BrandLockup = ({ className = "h-14" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 200 60"
    className={`${className} w-auto mx-auto`}
    role="img"
    aria-label="Reflecta"
  >
    <defs>
      <linearGradient id="brandLockupGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#9B30FF" />
        <stop offset="100%" stopColor="#6A0DAD" />
      </linearGradient>
    </defs>
    <g>
      <rect
        x="10"
        y="10"
        width="40"
        height="40"
        rx="10"
        ry="10"
        fill="url(#brandLockupGradient)"
      />
      <line x1="30" y1="10" x2="30" y2="50" stroke="#FFFFFF" strokeWidth="1.5" />
      <path
        d="M20 25 Q 25 18, 30 25 Q 35 32, 40 25"
        stroke="#FFFFFF"
        strokeWidth="2"
        fill="none"
      />
      <path
        d="M20 35 Q 25 42, 30 35 Q 35 28, 40 35"
        stroke="#FFFFFF"
        strokeWidth="2"
        fill="none"
        opacity="0.7"
      />
    </g>
    <text
      x="60"
      y="38"
      fontFamily="'Plus Jakarta Sans', sans-serif"
      fontWeight="400"
      fontSize="24"
      fill="#171717"
    >
      Reflecta
    </text>
  </svg>
);

export default BrandLockup;
